<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        ポリシー
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">ポリシー</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> ポリシー一覧
      </template> -->
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 登録日
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1日</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1月</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">月</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> 最終更新日
                <b-button size="sm" variant="info" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1日</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1月</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'updated_at')">週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'updated_at')">月</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_description">説明</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_description" v-model="so.opt['description']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">一致タイプ</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:すべて一致</b-form-radio>
                <b-form-radio value="or">[OR]:最低でも1つは一致</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 検索 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> リセット </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 閉じる </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <b-row>
        <b-col sm="6">
          <span class="text-center" v-b-tooltip.hover title="1 ページのビュー数を指定する">
            表示回数
            <select v-model="so.perPage" @change="refresh">
              <option value="15">デフォルト 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">説明</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }">詳細検索</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate}}</template>
        <template slot="count" slot-scope="row">
          {{row.item.count | number}} サイトスキャンで使用
        </template>
        <template slot="description" slot-scope="row" v-if="row.item.policy">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.description  || '-'}}
          </a>
        </template>
        <template slot="policy" slot-scope="row" v-if="row.item.policy">{{row.item.policy.limit | number}}</template>
        <template slot="updated_at" slot-scope="row">{{row.item.updated_at | datetime}}</template>
        <template slot="func" slot-scope="row">
          <b-btn v-if="use_view == false" @click="detail(row.item)" size="sm" variant="outline-primary">選択</b-btn>
          <b-btn v-else @click="detail(row.item)" size="sm" variant="outline-primary">詳細</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="4"></b-col>
        <b-col md="4">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="4" v-if="use_view != false">
          <div class="pull-right">
            <b-button class="btn-add" size="sm" :limit="10" variant="success" @click="$router.push({ name: 'wmds_policy', params: { id : 'add' } })"> 新規登録 </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
